import { Card, CardContent, PageHeader } from '@estac1/ui';
import { AuditEntries } from './audit/audit-entries.js';
import { AuditFilters } from './audit/audit-filters.js';
import { useAudit } from './audit/use-audit.js';

export const AuditScreen = () => {
  const {
    facets,
    audit,
    expanded,
    toggle,
    entries,
    actionFilter,
    setActionFilter,
    entityFilter,
    setEntityFilter,
    actorFilter,
    setActorFilter,
    idQuery,
    setIdQuery,
    clearFilters,
    hasActiveFilter,
  } = useAudit();

  return (
    <div className="space-y-6">
      <PageHeader title="Auditoria" description="Cada ação destrutiva fica registrada." />

      <Card>
        <CardContent className="space-y-3 pt-6">
          <AuditFilters
            facets={facets}
            actionFilter={actionFilter}
            entityFilter={entityFilter}
            actorFilter={actorFilter}
            idQuery={idQuery}
            onActionFilter={setActionFilter}
            onEntityFilter={setEntityFilter}
            onActorFilter={setActorFilter}
            onIdQuery={setIdQuery}
            entriesCount={entries.length}
            hasNextPage={audit.hasNextPage}
            hasActiveFilter={hasActiveFilter}
            onClearFilters={clearFilters}
          />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="px-0 pt-0 sm:px-6">
          <AuditEntries
            audit={audit}
            entries={entries}
            expanded={expanded}
            onToggle={toggle}
            hasActiveFilter={hasActiveFilter}
          />
        </CardContent>
      </Card>
    </div>
  );
};
